import { useState, useEffect } from 'react';
import axios from 'axios';
import ReactLoading from 'react-loading';
import { MdAccountCircle } from 'react-icons/md';
import { LiaStarSolid } from 'react-icons/lia';
import { formatDateStrToDate, formatRating, getToken } from '../utils';

function AllReferer() {
  const [isLoading, setIsLoading] = useState(false);
  const [referers, setReferers] = useState([]);

  const { token: userToken } = getToken();

  useEffect(() => {
    const fetchAllReferes = async () => {
      try {
        setIsLoading(true);
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/referrals`,
          {
            headers: { Authorization: `Bearer ${userToken}` },
          }
        );
        setReferers(response.data);
      } catch (error) {
        console.log(error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchAllReferes();
  }, [userToken]);

  return (
    <section className='w-full bg-p-wh py-8 shadow-lg mr-6 '>
      <h3 className='font-semibold text-[18px] text-p-bk pb-3 px-6'>
        Users You Referered
      </h3>{' '}
      <div className='max-h-80 overflow-y-scroll'>
        {isLoading ? (
          <div className='w-full h-full flex justify-center'>
            <ReactLoading type='cylon' color='#5AC8FA' height={44} width={44} />
          </div>
        ) : referers.length === 0 ? (
          <div className='w-full h-full flex px-6'>
            <p className='font-medium'>No referrer</p>
          </div>
        ) : (
          referers?.map((referer) => (
            <div
              className='flex flex-row justify-between text-sm border-t-hf py-3 px-6'
              key={referer.id}
            >
              <div className='flex flex-row gap-2'>
                <MdAccountCircle className='text-4xl text-b-mc/70 ' />

                <div className='flex flex-col capitalize '>
                  <span>{referer?.referred?.first_name}</span>

                  <p className='flex flex-row gap-2 items-center text-xs text-s-bk'>
                    Rating {formatRating(referer?.referred?.rating)}
                    <LiaStarSolid className='text-green-500' />
                  </p>
                </div>
              </div>
              <p className='text-s-bk'>
                {formatDateStrToDate(referer?.created_at)}
              </p>
            </div>
          ))
        )}{' '}
      </div>
    </section>
  );
}

export default AllReferer;
